import { type FC } from "react";

export const PartnerRegistrationBackground: FC = () => (
    <>
        <div
            className={
                "bg-linear-to-tr from-cyan-500 fixed inset-0 opacity-75 z-0 top-[50px] pointer-events-none"
            }
        />
        <div
            className={
                "bg-linear-to-t from-indigo-500 fixed inset-0 opacity-40 -left-16 -bottom-16 z-10 " +
                "top-[50px] pointer-events-none"
            }
        />
    </>
);
